export default {
	sec_10: {
		title: {
			one: 'About the ',
			two: 'company',
		},
		desc: {
			one: 'We handle security and management.',
			two: 'You just need to focus on operations.',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_11: {
		one: {
			title: {
				one: 'Affiliate management is',
				two: 'also automatic',
			},
			desc: {
				one: 'Are you still managing everything?',
				two: 'Just use JP WORLD Pay and it will be done automatically.',
			},
		},
		two: {
			title: {
				one: 'Sign up and complete',
				two: 'store registration',
			},
			desc: {
				one: 'Free franchise management program.',
				two: 'Lifetime use is free, with no fees.',
			},
		},
	},
};
